import { render, staticRenderFns } from "./CustomersTypesFunnelGraph.vue?vue&type=template&id=31f7023b&scoped=true"
import script from "./CustomersTypesFunnelGraph.vue?vue&type=script&lang=js"
export * from "./CustomersTypesFunnelGraph.vue?vue&type=script&lang=js"
import style0 from "./CustomersTypesFunnelGraph.vue?vue&type=style&index=0&id=31f7023b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f7023b",
  null
  
)

export default component.exports